export const LOCAL_WORKSPACE_NAME = "local";
